import ClipPlayerSkeleton from './components/ClipPlayerSkeleton';
import TimelineSkeleton from './components/TimelineSkeleton';
import TranscriptSkeletonContainer from './components/TranscriptSkeletonContainer';

const ClipSkeletonLoader = () => {
  return (
    <div className="flex size-full flex-col">
      <div className="flex h-4/5 w-full py-4">
        <div className="w-[32%]">
          <TranscriptSkeletonContainer />
        </div>
        <div className="flex-1">
          <ClipPlayerSkeleton />
        </div>
      </div>
      <div className="w-full flex-1 pr-2">
        <TimelineSkeleton />
      </div>
    </div>
  );
};

export default ClipSkeletonLoader;
